<app-details-page-header
  [title]="contact()?.email ?? ''"
  [id]="contactId || ''"
  (back)="goBack()"
>
  <app-button
    [loading]="isResetting"
    [disabled]="isResetting"
    [iconClass]="'fas fa-key'"
    [label]="'admin.users.actions.resetPassword' | translate"
    btnClass="btn btn-falcon-default btn-sm d-flex align-items-center gap-2"
    (clicked)="onResetPassword()"
  />

  <app-button
    [loading]="isToggling"
    [disabled]="isToggling"
    [iconClass]="isDeactivated ? 'fas fa-play' : 'fas fa-pause'"
    [label]="
      isDeactivated
        ? ('admin.users.actions.reactivate' | translate)
        : ('admin.users.actions.suspend' | translate)
    "
    (clicked)="onToggleActivation()"
  />

  <button
    class="btn btn-falcon-default btn-sm d-flex align-items-center gap-2"
    type="button"
  >
    <i class="fas fa-trash-alt"></i> {{ "general.remove" | translate }}
  </button>
</app-details-page-header>

<!-- Main content -->
<div class="card card-details shadow-sm border-0 py-2 mt-3">
  <ul class="nav nav-tabs mb-2" role="tablist">
    <li class="nav-item" role="presentation" *ngFor="let tab of tabs">
      <a
        class="nav-link"
        [class.active]="activeTab === tab.key"
        role="tab"
        [attr.aria-controls]="tab.key"
        [attr.aria-selected]="activeTab === tab.key"
        (click)="setTab(tab.key)"
      >
        {{ tab.label | translate }}
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab === 'details'"
      [class.active]="activeTab === 'details'"
      id="details"
      role="tabpanel"
    >
      <app-details-tab [contact]="contact"></app-details-tab>
    </div>

    <div
      class="tab-pane fade m-2"
      [class.show]="activeTab === 'projects'"
      [class.active]="activeTab === 'projects'"
      id="entities"
      role="tabpanel"
    >
      <app-projects-tab [contact]="contact"></app-projects-tab>
    </div>
  </div>
</div>

<!-- Footer buttons only for the DETAILS tab -->
@if (activeTab === 'details') {
<div class="d-flex justify-content-end gap-2 px-4 pb-4">
  <app-button
    [loading]="isCancelling"
    [disabled]="isSaving || isCancelling"
    [label]="'general.cancel' | translate"
    variant="default"
    (clicked)="onCancelDetails()"
  />

  <app-button
    [loading]="isSaving"
    [disabled]="isSaving || isCancelling"
    [iconClass]="'fas fa-save'"
    [label]="'general.save' | translate"
    btnClass="btn btn-primary btn-sm action-btn"
    (clicked)="onSaveDetails()"
  ></app-button>
</div>

}
